const ROOT = "settings-floating-desktop";
export {
  ROOT
};
//# sourceMappingURL=data-hooks.js.map
